module.exports = __webpack_public_path__ + "static/img/Dyson-Heppell.6aaacea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dyson-Heppell.jpg
// module id = qVcj
// module chunks = 0